// Main export file for the icons directory
// Provides a single entry point for all icon-related imports

// Export React icon components
export * from './react'

// Export SVG assets
export * from './svg'

// Export company logo icons
export * from './company-logos'

// Export types and utilities
export * from './types'
export * from './utils'

// Re-export common types for convenience
export type { LucideIconProps, IconProps, VariantIconProps, LogoIconProps, IconSize } from './types'
export { IconSizes } from './types'

// Re-export utilities for convenience
export { createIconDefaults, calculateStrokeWidth, mergeIconClasses } from './utils'
